import { atom } from 'recoil';

export const isSortingInfoModalOpenAtom = atom({
  key: 'isSortingInfoModalOpenAtom',
  default: false,
});
